export default __webpack_public_path__ + "static/media/phone_icon.4c5f1806.svg";